import { z } from 'zod';

export const ParticipantSchema = z.object({
  firstName: z.string({ message: 'Le prénom est obligatoire' }).optional(),
  lastName: z.string({ message: 'Le nom est obligatoire' }).optional(),
  birthDate: z.date({ message: 'Doit être une date valide' }).optional(),
});

export const ProjectSchema = z.object({
  name: z
    .string({ message: 'Le nom du projet est obligatoire' })
    .min(1, 'Le nom du projet est obligatoire'),
  clientFirstName: z.string().optional(),
  adults: z
    .array(ParticipantSchema)
    .min(1, { message: 'Au moins un adulte est requis' }),
  children: z
    .array(ParticipantSchema)
    .refine(
      (children) => children.every(({ birthDate }) => birthDate != undefined),
      { message: 'La date de naissance est obligatoire' },
    ),
});

export type ProjectFormData = z.infer<typeof ProjectSchema>;

export const TourOperatorProjectSchema = z.object({
  name: z
    .string({ message: 'Le nom du client est obligatoire' })
    .min(1, 'Le nom du client est obligatoire'),
  clientFirstName: z
    .string({ message: 'Le prénom est obligatoire' })
    .min(1, 'Le prénom est obligatoire'),
  adults: z.array(ParticipantSchema),
  children: z
    .array(ParticipantSchema)
    .refine(
      (children) =>
        children.length === 0 ||
        children.every(({ birthDate }) => birthDate != undefined),
      { message: 'La date de naissance est obligatoire' },
    ),
});

export type TourOperatorProjectFormData = z.infer<
  typeof TourOperatorProjectSchema
>;
